
Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.Scheduler = (function () {

    function Scheduler() {

        this.className = 'form_DataImport';
        this.mappingTemplate = new Greenmile.DataImport.MappingTemplate();
        this.rootEl = document.createElement("div");
        this.listOfSchedules = [];

        var customFilter = {
            rootEntity: App.Forms.DataImport.EntityList.getSelected()
        };

        this.show = function (self) {
            this.render(self);
        };

        this.requestSchedulerList = function() {
            var request = new Monet.Ajax ();

            request.url = 'ImportSchedule?entity=' + App.Forms.DataImport.EntityList.getSelected() + "&type="+ this.type;
            request.method = 'GET';
            request.success = (function (data) {

                if(data) {
                    this.listOfSchedules = data;
                    data = data.map(function (item) {
                        return {
                            key: item.name,
                            id: item.id
                        };
                    });
                    this.scheduleList.successOfRequestData(data);
                    this.changeScheduler();
                }

            }.bind(this));

            request.error = function(error) {
                Greenmile.DataImport.Utils.showErrorMessage(error.responseText);
            };

            request.send();
        };

        this.refreshScheduleList = function () {
            this.scheduleList.setCustomFilter(JSON.stringify(customFilter));

            this.scheduleList.rootEl.removeChild(this.scheduleList.input);
            this.scheduleList.render();
            this.scheduleList.setListenerOnChange(this.changeScheduler.bind(this));
            this.scheduleList.requestData = this.requestSchedulerList.bind(this);
        };

        this.renderScheduleList = function () {

            var list = new Monet.UI.Fields.PickList();
            list.setId('SchedulerList');
            list.setDisplayKey('key');
            list.setCustomFilter(JSON.stringify({
                entity: App.Forms.DataImport.EntityList.getSelected(),
                type: this.type
            }));
            list.requestData = this.requestSchedulerList.bind(this);

            list.render();
            list.setTextLabel(Monet.I18n.getResourcesByKey('Greenmile.DataImport.SchedulerList'));

            list.addPostRender(function() {
                var firstOption = list.input.options[0];
                firstOption.value = 'NEW';
                firstOption.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.newSchedule');
                firstOption.selected = 'selected';
            }.bind(this));

            list.setListenerOnChange(this.changeScheduler.bind(this));

            this.scheduleList = list;

            return list;

        };

        this.renderScheduleName = function () {
            var name = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.name',
                type: 'TEXT',
                name: 'name',
                mandatory: true
            });
            this.scheduleName = name.render();

            return this.scheduleName;

        };

        this.renderScheduleTime = function () {
            var container = document.createElement('div');
            container.className = 'optionContainer';

            var fieldDomains = [
                {
                    description: 'Greenmile.DataImport.schedulerInterval',
                    value: 'INTERVAL'
                },
                {
                    description: 'Greenmile.DataImport.everyDayAt',
                    value: 'EVERYDAY'
                }
            ];

            this.schedulerInterval = new Monet.UI.Fields.Render({
                label: '',
                type: 'RADIO_GROUP',
                id: 'scheduler',
                fieldDomains: fieldDomains

            }).render();
            this.schedulerInterval.setId('schedulerInterval');

            var radioGroupOptions = this.schedulerInterval.rootEl.querySelectorAll('#RadioItem_scheduler');
            radioGroupOptions[0].className += ' interval';
            radioGroupOptions[1].className += ' everyday';

            this.runInterval = new Monet.UI.Fields.Render({
                type: 'INTEGER',
                id: 'scheduler'
            }).render();

            this.runInterval.setId('schedulerInteger');

            var timeOptions = [
                {
                    description: 'Greenmile.DataImport.minutes',
                    value: 'MINUTE'
                },
                {
                    description: 'Greenmile.DataImport.hours',
                    value: 'HOUR'
                },
                {
                    description: 'Greenmile.DataImport.days',
                    value: 'DAY'
                },
                {
                    description: 'Greenmile.DataImport.weeks',
                    value: 'WEEK'
                }
            ];

            this.runIntervalUnit = new Monet.UI.Fields.Render({
                label: '',
                type: 'PICKLIST',
                fieldDomains:timeOptions
            }).render();

            this.runIntervalUnit.setId('scheduler');
            this.runIntervalUnit.removeOption(0);
            this.runIntervalUnit.setValue ('HOUR');

            radioGroupOptions[0].appendChild(this.runInterval.rootEl);
            radioGroupOptions[0].appendChild(this.runIntervalUnit.rootEl);

            this.timeDay = new Monet.UI.Fields.Render({
                label: '',
                type: 'TIME',
                id: 'scheduler'
            }).render();

            this.timeDay.setId('schedulerEveryDay');

            radioGroupOptions[1].appendChild(this.timeDay.rootEl);

            this.timeZone = new Monet.UI.Fields.Render({
                label: 'TimeZone',
                type: 'LOOKUP',
                name: 'timeZone',
                lookupEntity: 'TimeZone',
                lookupEntityColumn: 'description',
                mandatory: true
            }, 'TimeZone').render();

            container.appendChild(this.timeZone.rootEl);
            
            container.appendChild(this.schedulerInterval.rootEl);
            
            return container;
        };

        this.handlerToogleLoadingInBtn = () => {
            [this.btnSave, this.btnSaveAndProcess, this.btnDelete].map(button => button.toggleLoadingInBtn());
        };

        this.updateOrSave = function (callback, url, method) {
            
            let data = this.getValue();

            var validate = this.validate(data);
            if(validate.status) {
                this.handlerToogleLoadingInBtn();

                var ajax = new Monet.Ajax();
                ajax.url = url;
                ajax.method = method;
                ajax.data = data;
                ajax.success = () => {
                    this.handlerToogleLoadingInBtn();
                    callback && callback();
                };
                ajax.error = (error) => {
                    this.handlerToogleLoadingInBtn();
                    Greenmile.DataImport.Utils.showErrorMessage(error.responseText);
                };
                ajax.send();

            } else {
                Greenmile.DataImport.Utils.showErrorMessage(validate);
            }
        };

        this.SaveAndProcess = function () {
            const data = this.getValue();
            const { id } = data;
            const url = id ? `ImportSchedule/${id}/Process` : 'ImportSchedule/SaveAndProcess';
            const method = id ? 'PUT' : 'POST';
            this.updateOrSave(this.refreshScheduleList.bind(this), url, method);
        };

        this.Save = function () {
            const data = this.getValue();
            const { id } = data;
            const url = id ? `ImportSchedule/${id}` : 'ImportSchedule/Save';
            const method = id ? 'PUT' : 'POST';
            this.updateOrSave(this.refreshScheduleList.bind(this), url, method);
        };

        this.Delete = function () {
            this.handlerToogleLoadingInBtn();
            var ajax = new Monet.Ajax();
            ajax.url = "ImportSchedule/Delete/" + this.scheduleList.getValue();
            ajax.method = "DELETE";
            ajax.success = function () {
                new Greenmile.Components.AlertModal("DataImport.Scheduler.Removed")
                    .show();
                this.refreshScheduleList();
                this.handlerToogleLoadingInBtn();
            }.bind(this);
            ajax.error = function(error) {
                this.handlerToogleLoadingInBtn();
                Greenmile.DataImport.Utils.showErrorMessage(error.responseText);
            }.bind(this);
            ajax.send();

        };

        this.renderButtons = function () {

            var container = document.createElement("div");
            container.className = "buttons";

            this.btnSaveAndProcess = new Monet.UI.Fields.Render({
                customJavaScript: this.SaveAndProcess.bind(this),
                label: 'default.button.saveAndProcess',
                type: 'BUTTON'
            }).render();

            this.btnSave = new Monet.UI.Fields.Render({
                customJavaScript: this.Save.bind(this),
                label: 'default.button.save',
                type: 'BUTTON'
            }).render();

            this.btnDelete = new Monet.UI.Fields.Render({
                customJavaScript: this.Delete.bind(this),
                label: 'DataImport.deleteScheduler',
                type: 'BUTTON'
            }).render();
            this.btnDelete.setId('deleteSchedule');
            this.btnDelete.setClassName('btn-delete');
            this.btnDelete.rootEl.style.display = 'none';


            container.appendChild(this.btnSave.rootEl);
            container.appendChild(this.btnSaveAndProcess.rootEl);
            container.appendChild(this.btnDelete.rootEl);

            return container;
        };

        this.validateInterval = function(data, validateObj) {
            var item = this.schedulerInterval.rootEl.querySelector('.radio_group_item.interval');
            item.className = item.className.replace('control-group error', '') ;

            if(this.schedulerInterval.getValue() === "INTERVAL" && (!data.runInterval ||  !data.runIntervalUnit) )  {
                item.className += ' control-group error';
                validateObj.errorMessages.push(
                  Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.intervalIsMandatory'));
            }

            item = this.schedulerInterval.rootEl.querySelector('.radio_group_item.everyday');
            item.className = item.className.replace('control-group error', '') ;

            if(this.schedulerInterval.getValue()  === "EVERYDAY" && !data.runAt) {
                item.className += ' control-group error';
                validateObj.errorMessages.push(
                  Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.runAtIsMandatory'));
            }
        };

        this.validateLayout = function(data, validateObj) {
            var item = this.mappingTemplate.rootEl;
            item.className = item.className.replace('control-group error', '') ;
            if(!data.layout || !data.layout.id) {
                item.className += ' control-group error';
                validateObj.errorMessages.push(
                  Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.layoutIsMandatory'));
            }
        };

        this.validateFields = function(fieldsToValidate, validateObj) {
            for(var i in fieldsToValidate) {
                this[fieldsToValidate[i]].rootEl.className = this[fieldsToValidate[i]].rootEl.className.replace('control-group error', '') ;
                var fieldErrors = this[fieldsToValidate[i]].validate();
                if(fieldErrors && fieldErrors.length > 0){
                    validateObj.status = false;
                    validateObj.errorMessages = validateObj.errorMessages.concat(fieldErrors);
                }
            }
        };

        this.clearAndAppendRootEl = function(rootClassName) {
            var container = document.querySelector("." + this.className);
            container.innerHTML = '';
            container.appendChild(this.rootEl);
            container.parentNode.setAttribute('screen', rootClassName);
        };

        this.toggleDeleteScheduleBtn = function (scheduleId) {
          const btn = document.querySelector('#deleteSchedule');
          if (btn) {
            let display = 'none'
            if (scheduleId !== 'NEW') {
              display = 'block';
            }
            btn.style.display = display;
          }
        }

        this.appendTitle = function(resource) {
            const title = document.createElement('div');
            title.className = 'title';
            title.innerHTML = Monet.I18n.getResourcesByKey(resource);
            this.rootEl.appendChild(title);
        };

    }

    return Scheduler;
}());